












































import {Vue, Component, Prop} from 'vue-property-decorator';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import AlterationReferences from "@/modules/budget/alteration/form/tabs/AlterationReferences.vue";
import AlterationReferencesABP from "@/modules/budget/alteration/form/tabs/AlterationReferencesABP.vue";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";

interface AccessModule {
    modules: string;
    active?: boolean;
    is_in_hierarchy?: boolean;
    position?: string;
    operations?: any[];
}

interface AccessLevels {
    is_in_hierarchy: boolean;
    position?: string;
    operations: any[];
    active: boolean;
}

@Component({
    components: {
        'alteration-references-ipf': AlterationReferences,
        'alteration-references-abp': AlterationReferencesABP,
    }
})
export default class RefForm extends AlterationI18nMixin {
    @Prop({
        required: true,
        default: null
    })
    public requestTypeOptions: any;
    @Prop({
        required: true,
        default: null
    })
    public regionBase: any;
    @Prop({
        required: true,
        default: null
    })
    public yearList: any;
    @Prop({
        required: true,
        default: null
    })
    public userId: any;
    @Prop({
        required: true,
        default: null
    })
    public accessModules: any;

    @Prop({
        type: Boolean,
        default: false
    })
    public reLoadChild: boolean = false;

    @Prop({
        required: true,
        default: null
    })
    public applicationsItem: any;

    @Prop({
        type: Boolean,
        required: true,
        default: true
    })
    public isLoadToJournalEnabled!: boolean;


    private referencesGU = false;
    private referencesABP = false;
    private mCodeRequestGA = '005.002.001';
    private mCodeReferenceABP = '005.002.007';
    private accessLevelsGA = {
        is_in_hierarchy: false,
        active: false
    };
    private accessLevelsRefABP = {
        is_in_hierarchy: false,
        active: false
    };
    get showReferencesGUTab(): boolean {
        return this.accessLevelsGA?.is_in_hierarchy === true;
    }

    get showReferencesABPTab(): boolean {
        return this.accessLevelsRefABP?.is_in_hierarchy === true;
    }
    public created() {
        this.$watch('reLoadChild', () => { if (this.reLoadChild) { setTimeout(() => this.$emit('reLoadC', false), 1000); }});
        this.$watch('applicationsItem', () => {
            if (this.applicationsItem.requestType === 'individual') {
                this.referencesABP = this.applicationsItem && this.applicationsItem !== null && this.applicationsItem.requestType === 'individual';
                // eslint-disable-next-line
                // @ts-ignore
                this.$refs.altRefAbp.altRefAbp(this.applicationsItem);
                // Индивидуальная заявка (AlterationForm.refsABPActive) — открываем «Справки АБП» по самой вкладке,
                // а не по индексу: индекс в b-tabs зависит от того, какие вкладки доступны пользователю
                this.$nextTick(() => {
                    // eslint-disable-next-line
                    // @ts-ignore
                    this.$refs.referenceABPTab?.activate();
                });
            }

        });
        this.$watch('accessModules', () => {
            this.$nextTick(() => {
                this.accessLevelsGA = this.accessModules.find((item: AccessModule) => item.modules === this.mCodeRequestGA);
                this.$set(this, 'referencesGU', this.accessLevelsGA?.active);

                this.accessLevelsRefABP = this.accessModules.find((item: AccessModule) => item.modules === this.mCodeReferenceABP);
                this.$set(this, 'referencesABP', this.accessLevelsRefABP?.active);
            });
        });
    }
    public async mounted() {}
    private referencesABPActive(currentAlteration: {}){
        // eslint-disable-next-line
        // @ts-ignore
        if (this.accessLevelsRefABP.position === 'abp') {
            // eslint-disable-next-line
            // @ts-ignore
            if (currentAlteration.requestType === 'individual') {
                // eslint-disable-next-line
                // @ts-ignore
                this.$emit('refsABPActive', currentAlteration);
                // this.$refs.altRefAbp.altRefAbp(currentAlteration);
                // eslint-disable-next-line
                // @ts-ignore
                this.referencesGU = false;
                this.referencesABP = true;
            } else {
                // eslint-disable-next-line
                // @ts-ignore
                this.referencesGU = false;
                // eslint-disable-next-line
                // @ts-ignore
                this.referencesABP = false;
                // eslint-disable-next-line
                // @ts-ignore
                this.$emit('applsABPActive', currentAlteration);
            }
        }
        else {

        }
    }
    private onUnReLoad(val: boolean) {
        this.$emit('unReLoad', val);
    }
    private onReload(val: boolean) {
        this.$emit('reLoadC', val);
    }
}
